import { ExternalLink } from "lucide-react";
import { useBlocks } from "@/hooks/useContent";

const GIVE_URL = "https://www.patria.church/give";

const cleanHref = (url) => {
  try {
    const u = new URL(url || GIVE_URL);
    return u.protocol === "https:" ? `${u.origin}${u.pathname}` : GIVE_URL;
  } catch {
    return GIVE_URL;
  }
};

const STYLES = {
  card: { wrap: "surface max-w-2xl p-6", title: "text-2xl", text: "mt-3 space-y-3 text-ink-900", verse: "mt-5 border-l-2 border-sage-400 pl-4 text-sm italic text-ink-500" },
  inline: { wrap: "mt-5 border-l-2 border-olive-900/40 pl-4", title: "font-serif text-lg font-semibold", text: "mt-2 space-y-2 text-sm text-ink-900", verse: "mt-3 text-xs italic text-ink-500" },
  quiet: { wrap: "mt-14 max-w-2xl border border-sage-400/60 bg-cream-100 p-6", title: "font-serif text-xl font-semibold", text: "mt-2 space-y-2 text-ink-500", verse: "mt-4 text-sm italic text-ink-500" },
};

export const FreelyGiven = ({ variant = "card", testId = "freely-given" }) => {
  const { data: blocks } = useBlocks();
  const block = blocks?.["shared.freely_given"];
  if (!block) return null;
  const paragraphs = block.body.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
  const verse = paragraphs.length > 1 ? paragraphs[paragraphs.length - 1] : null;
  const body = verse ? paragraphs.slice(0, -1) : paragraphs;
  const s = STYLES[variant] || STYLES.card;
  return (
    <aside className={s.wrap} aria-labelledby={`${testId}-h`} data-testid={testId}>
      <h2 id={`${testId}-h`} className={s.title}>{block.title}</h2>
      <div className={s.text}>{body.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}</div>
      <a href={cleanHref(block.url)} target="_blank" rel="noopener noreferrer" className={`${variant === "inline" ? "btn-secondary min-h-[40px] text-sm" : "btn-secondary"} mt-4 inline-flex items-center gap-2`} data-testid={`${testId}-give`}>
        Give To Patria <ExternalLink className="h-4 w-4" aria-hidden="true" />
      </a>
      {verse && <p className={s.verse} data-testid={`${testId}-verse`}>{verse}</p>}
    </aside>
  );
};
